import React from 'react';
import UN383ComplianceSection from '../components/UN383ComplianceSection';
import SEOHead from '../components/SEOHead';

const SafetyPage = () => {
  return (
    <div className="pt-20">
      <SEOHead 
        title="Battery Safety | UN 38.3 Certified | Non-Lithium Battery India"
        description="UN 38.3 certified industrial batteries in India. Inherently safer Multi-Ion technology - no thermal runaway, no fire risk. Tested and certified for air, sea, and ground transport. ISO 9001:2015 quality."
        keywords="UN 38.3 certified battery, safe industrial battery, non-lithium battery India, fire safe battery, thermal runaway free battery, battery safety certification, ISO certified battery India"
        canonicalPath="/safety"
      />
      <section className="py-12 sm:py-16 bg-gradient-to-b from-gray-900 to-gray-950">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-3xl sm:text-4xl lg:text-5xl xl:text-6xl font-bold text-white mb-4 sm:mb-6">
            Safety <span className="text-emerald-400">First</span>
          </h1>
          <p className="text-base sm:text-lg lg:text-xl text-gray-400 max-w-3xl mx-auto">
            Multi-Ion technology is inherently safer than lithium-ion. All cells and packs are UN 38.3 certified.
          </p>
        </div>
      </section>
      <UN383ComplianceSection />
    </div>
  );
};

export default SafetyPage;
